import Section from '../Section'
import ReadMore from '../ReadMore'
import { ListingAgent } from './ListingAgent'
import { defineMessages, useIntl } from 'react-intl'
import { EVERY_STATE, ListingDetailsListing } from 'src/types/listings'
import { ContactHomebotButton } from '../ContactHomebot/ContactHomebotButton'
import { DataProvidedByMlsAbbrevAndNumberWithLogo } from '../../Compliance/DataProvidedByMlsAbbrevAndNumberWithLogo'

import styles from './Description.module.scss'

const MSG = defineMessages({
  desc: {
    id: 'HomeSearch.listingDetails.description',
    defaultMessage: 'Description',
  },
})

export interface DescriptionProps {
  className?: string
  listing: ListingDetailsListing
}

export const Description = ({ listing, className }: DescriptionProps) => {
  const intl = useIntl()
  const showContactBtn = listing?.source?.name === EVERY_STATE

  return (
    <Section className={className}>
      <Section.Heading>{intl.formatMessage(MSG.desc)}</Section.Heading>
      <Section.Body>
        <ReadMore text={listing?.description} truncateCount={500} />
        {listing?.providedBy && <ListingAgent agent={listing.providedBy} />}
        <div className={styles.sectionFooter}>
          {showContactBtn && <ContactHomebotButton />}
          <DataProvidedByMlsAbbrevAndNumberWithLogo listing={listing} />
        </div>
      </Section.Body>
    </Section>
  )
}
